import { cherryPickState } from "@cede/utils";
import { useCedeStore } from "../hooks/useCedeStore";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTheme, Card, Typography, Grid } from "@mui/material";

export const CheckConnection = () => {
  const theme = useTheme();
  const { vaults, provider } = useCedeStore(cherryPickState(["vaults", "provider"]));

  return (
    <Card
      id={`checkConnection`}
      sx={{
        bgcolor: theme.palette.background.component,
        borderRadius: theme.custom.largeBoxRadius,
        padding: theme.custom.gutterMargin,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.custom.gutterMargin,
      }}
    >
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={4} sx={{ display: "flex", justifyContent: "center" }}>
          {provider ? (
            <CheckCircleIcon id={"provider-available"} sx={{ color: theme.palette.text.primary }} />
          ) : (
            <CancelIcon sx={{ color: theme.palette.cedeErrorColor }} />
          )}
        </Grid>
        <Grid item xs={8}>
          {provider ? (
            <Typography sx={{ color: theme.palette.text.primary }}> Provider available</Typography>
          ) : (
            <Typography sx={{ color: theme.palette.cedeErrorColor }}> Provider not available</Typography>
          )}
        </Grid>

        <Grid item xs={4} sx={{ display: "flex", justifyContent: "center" }}>
          {vaults.length ? (
            <CheckCircleIcon id={"extension-connected"} sx={{ color: theme.palette.text.primary }} />
          ) : (
            <CancelIcon sx={{ color: theme.palette.text.disabled }} />
          )}
        </Grid>
        <Grid item xs={8}>
          {vaults.length ? (
            <Typography sx={{ color: theme.palette.text.primary }}> Extension connected</Typography>
          ) : (
            <Typography sx={{ color: theme.palette.text.disabled }}> Extension not connected</Typography>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};
